import Image from "components/atoms/Image";
import { breakPoint } from "lib/constants";
import useTranslation from "next-translate/useTranslation";
import React, { FC } from "react";
import styled from "styled-components";
import ToTopButton from "~/components/atoms/button/ToTopButton";
import Layout from "faqSrc/components/layout/Layout";
import { MetaTag } from "faqSrc/components/modules/metaTag";
import { staticPath } from "faqSrc/lib/$path";

interface Props {
  message: string;
  title?: string;
}

const TemplateError: FC<Props> = ({ title = "エラーページ", message }) => {
  const { t } = useTranslation();
  return (
    <Layout hideHeader>
      <>
        <MetaTag title={title} isNoIndexPage={true} />
        <Content className="content-wrap">
          <ImageWrap>
            <Image
              src={staticPath.img.sorry_png}
              width="120"
              height="120"
              alt="image sorry"
              display="inline"
              disableHover={true}
            />
          </ImageWrap>
          <Message>
            {message}
            <br />
            {t("frontPage:error.content", null, {
              fallback: "別のページを探してみて下さい。",
            })}
          </Message>
          <ToTopButton />
        </Content>
      </>
    </Layout>
  );
};

const Content = styled.div`
  padding-bottom: 80px;
`;

const ImageWrap = styled.div`
  margin-top: 92px;
  text-align: center;
`;

const Message = styled.div`
  font-weight: 700;
  font-size: 22px;
  line-height: 36px;
  color: var(--title-clr);
  text-align: center;
  margin: 40px auto 80px auto;

  @media only screen and (max-width: ${breakPoint["nr"]}) {
    font-size: 18px;
  }
`;

export default TemplateError;
